
import Transformer from './../transformer'
import { shortDate } from '@/filters'
import { assetURL, objectToForm } from '@/utils'
import imagePlaceholder from '@/assets/images/image_placeholder.jpg'

export default class ConceptFileTransformer extends Transformer {
  static fetch(conceptFile) {
    const { file, small_photo } = conceptFile
    const smallPhoto = small_photo ? assetURL(small_photo) : imagePlaceholder
    return {
      id: conceptFile.id,
      file: assetURL(file.file),
      fileId: file.id,
      conceptId: conceptFile.quantification_concept,
      fileTypeId: file.file_type,
      addDate: shortDate(conceptFile.add_date),
      clientVisibility: file.visible_customer,
      smallPhoto,
      isRejected: !file.is_active,
      size: conceptFile.size,
    }
  }

  static send(conceptFile) {
    return objectToForm({
      id: conceptFile.id ? conceptFile.id : undefined,
      file: conceptFile.file,
      quantification_concept: conceptFile.conceptId,
      file_type: conceptFile.fileType,
      visible_customer: conceptFile.clientVisibility,
    })
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/conceptFile.js